import { render } from "./transfer_v_expense.vue?vue&type=template&id=1286a27a&scoped=true"
import script from "./transfer_v_expense.vue?vue&type=script&lang=js"
export * from "./transfer_v_expense.vue?vue&type=script&lang=js"

import "./transfer_v_expense.vue?vue&type=style&index=0&id=1286a27a&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1286a27a"]])

export default __exports__